/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import moment from 'moment';
import MeetingDiv from './MeetingDiv';
import TimeDiv from './TimeDiv';
import RightClickMenu from './RightClickMenu';

class TimeTable extends React.Component {
  constructor(props) {
    super(props);
    this.makeMeetingDiv = this.makeMeetingDiv.bind(this);
    this.makeTimeTable = this.makeTimeTable.bind(this);
  }

  componentDidMount() {
    window._liWidth = this._right.offsetWidth / 10;
  }

  makeMeetingDiv(meetings, time, id) {
    let meetingsDiv = [];
    meetings.forEach(v => {
      if (moment(v.startTime).isSame(time, 'day')) {
        meetingsDiv.push(
          <div key={v.id}>
            <MeetingDiv roomId={id} {...this.props} meeting={v} />
            <RightClickMenu roomId={id} {...this.props} meeting={v} />
          </div>
        );
      }
    });
    return meetingsDiv;
  }

  makeTimeTable(meetings, id) {
    const { days, timeMap, handleByClickDay } = this.props;
    let timeTable = new Array(days);
    for (let i = 0; i < days; i++) {
      const meetingsDiv = this.makeMeetingDiv(meetings, timeMap.get(i), id);
      timeTable.push(
        <TimeDiv
          {...this.props}
          index={i}
          roomID={id}
          timeMap={timeMap}
          meetingsDiv={meetingsDiv}
          handleByClickDay={handleByClickDay}
          key={`${id}${timeMap.get(i).valueOf()}`}
        />
      );
    }
    return timeTable;
  }

  render() {
    const { room } = this.props;
    return (
      <ul
        className="table-right-div table-right-div-td table-right-div-week ul3"
        ref={c => (this._right = c)}
      >
        {this.makeTimeTable(room.meetings, room.id)}
      </ul>
    );
  }
}
export default TimeTable;



// WEBPACK FOOTER //
// ./src/components/meeting/TimeTable.js